import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { checkUrl } from '../../deployment'

@Injectable({
  providedIn: 'root'
})
export class AdminPanelService {
    constructor(private http: HttpClient, private router: Router) { }


// Requirement (Id *,title1,title2 , point1, point2)
  termConditionAndPrivacyPolicyEdit($data:any){
    return this.http.post(checkUrl()+"/homepage/edit-term-privacy",$data)
    .pipe((response)=>{
          return response;
    })
  }

  getAdminData() {
    return this.http.get(checkUrl()+"/admin/data")
    .pipe((response)=>{
          return response;
    })
  }
}
